'use client';

import './styles/default.scss';
import { ValueTicker } from '@/app/elements/value-ticker/value-ticker';
import { getText } from '@/utils/text/text';
import type { UpdatedJackpotTier } from '@/types/zones/slices/site-wide-jackpot-slice';
import { classes } from '@/utils/classes/classes';

type SingleJackpotCardProps = {
    jackpotTier: UpdatedJackpotTier;
    loading?: boolean;
};

export const SingleJackpotCard: React.FC<SingleJackpotCardProps> = ({ jackpotTier, loading = false }) => {
    const tierName = jackpotTier?.tier_name?.[0]?.text ?? '';
    const shortTierName = jackpotTier?.short_tier_name?.[0]?.text ?? '';

    return (
        <div className="single-jackpot-tier-card-wrapper">
            <img className="single-tier-icon" src={jackpotTier?.logo1?.url} alt={`${tierName} logo`} />
            <div className="single-tier-details">
                <p className="single-tier-title">{tierName.toUpperCase()}</p>
                <div
                    key={jackpotTier?.tier_id}
                    className={classes('single-tier-value', `single-tier-value-${shortTierName.toLowerCase()}`)}>
                    {loading ? (
                        <span>{getText({ text: 'components.siteWideJackpots.loadingStatus' })}</span>
                    ) : (
                        <ValueTicker
                            amount={jackpotTier?.currentAmount ?? 0}
                            prevAmount={jackpotTier?.prevAmount ?? 0}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
